import { Mail, Phone, MapPin, Clock } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/brand/logo.png'

export const Footer = () => {
	return (
		<footer className='bg-slate-950 text-slate-400 font-sans border-t border-slate-800'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16'>
				<div className='grid grid-cols-1 md:grid-cols-12 gap-10'>
					{/* Col 1: Brand Info */}
					<div className='md:col-span-5 flex flex-col items-start'>
						<img
							src={logo}
							alt='Africa Pipetek Logo'
							className='h-16 w-auto mb-4 brightness-200 grayscale contrast-200'
						/>
						<p className='text-sm leading-relaxed text-slate-400 max-w-sm'>
							Africa Pipetek is a premier supplier of high-density polyethylene
							(HDPE), PVC, and industrial piping infrastructure across Africa.
						</p>
					</div>

					{/* Col 2: Quick Links */}
					<div className='md:col-span-3'>
						<h4 className='font-heading text-sm font-bold text-white uppercase tracking-wider mb-4'>
							Quick Navigation
						</h4>
						<ul className='space-y-2.5 text-sm'>
							{['Home', 'About', 'Products', 'Contact'].map((item) => (
								<li key={item}>
									<NavLink
										to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
										className='hover:text-white transition-colors'>
										{item}
									</NavLink>
								</li>
							))}
						</ul>
					</div>

					{/* Col 3: Contact Info */}
					<div className='md:col-span-4'>
						<h4 className='font-heading text-sm font-bold text-white uppercase tracking-wider mb-4'>
							Contact Us
						</h4>
						<ul className='space-y-3 text-sm'>
							<li className='flex items-start gap-3'>
								<MapPin className='w-5 h-5 text-brand-blue shrink-0 mt-0.5' />
								<span>8/10 Combrinck Street, Alrode, Alberton, 1451</span>
							</li>
							<li className='flex items-center gap-3'>
								<Phone className='w-5 h-5 text-brand-blue shrink-0' />
								<a
									href='tel:+27100061277'
									className='hover:text-white transition-colors'>
									+27 (0) 10 006 1277
								</a>
							</li>
							<li className='flex items-center gap-3'>
								<Mail className='w-5 h-5 text-brand-blue shrink-0' />
								<a
									href='mailto:info@africapipetek.co.za'
									className='hover:text-white transition-colors'>
									info@africapipetek.co.za
								</a>
							</li>
							<li className='flex items-start gap-3'>
								<Clock className='w-5 h-5 text-brand-blue shrink-0 mt-0.5' />
								<div className='flex flex-col'>
									<span>Mon - Fri: 08:00 - 17:00</span>
									<span>Sat: 08:00 - 12:00</span>
								</div>
							</li>
						</ul>
					</div>
				</div>

				{/* Bottom Bar */}
				<div className='mt-12 pt-8 border-t border-slate-900 flex flex-col sm:flex-row justify-between items-center text-xs text-slate-500 gap-4'>
					<p>
						© {new Date().getFullYear()} Africa Pipetek (Pty) Ltd. All rights
						reserved.
					</p>
					<div className='flex gap-6'>
						<NavLink
							to='/terms'
							className='hover:text-slate-400 transition-colors'>
							Privacy Policy & Terms
						</NavLink>
					</div>
				</div>
			</div>
		</footer>
	)
}
